import {connect} from "react-redux";
import UCDActivityList from "./List";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../../service/Activity/action";
import { isCheckout } from "../../../../../service/CarService/action";
import {markAttendances} from "../../../../../service/Dealer/action";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {ratingSave} from "../../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    isCheckoutDetails:state.CarService.isCheckout,
    attendance:state.Dealer.attendance,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            isCheckout,
            markAttendances,
            documentUploadUrlPublic,
            ratingSave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDActivityList);
